module.exports = __webpack_public_path__ + "img/XM.e2353591.png";